module.exports = __webpack_public_path__ + "static/media/182.4c504937.jpg";